module.exports = __webpack_public_path__ + "static/system-design-course-2cac6314528695667a6f37c2d0216eb8.svg";